// eslint:disable max-line-length
import { validationHighlights, validationPrefixHighlights } from 'app/area/administration/shared/helpers';
import { CodetableTranslation } from 'app/area/codetable/constants';
import {
  shouldRenderDetails, shouldRenderTranslations, shouldRenderVisibility
} from 'app/area/codetable/item/codetable-item-form-render-helpers';
import { ScreenField, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { CodeEditSectionType, MetroLineConfigurationPayload } from 'app/area/codetable/item/types';
import { CodeFieldFlagWireKey, CodeFieldWireKey, CodetableFeature } from 'app/area/codetable/types-store';
import { Configuration } from 'app/components/metro-line/types';
import { routeConstants } from 'app/routes/route-constants';

export const substanceHierarchyConfiguration = ({ metadata, breadcrumbs, codeId, actionType, validationErrors,
  detailsSectionRef, unitOfMeasureDetailsSectionRef, unitOfMeasureSetsSectionRef, visibilitySectionRef, translationsSectionRef,
  conversionFactorsSectionRef
}: MetroLineConfigurationPayload):
  Configuration<CodeEditSectionType>[] => ([
    {
      section: CodeEditSectionType.Details,
      visible: shouldRenderDetails(metadata),
      iconUrl: '/i/case-sections/default.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Details, actionType),
      label: (translation: CodetableTranslation) => translation.details,
      ref: detailsSectionRef,
      isValid: validationHighlights([CodeFieldFlagWireKey.scoreCalcWeight,
      CodetableFeature.parent, CodetableFeature.node, CodetableFeature.category, CodetableFeature.icon, CodeFieldWireKey.colourCode,
      ScreenPicker.likelihood, ScreenPicker.recurrence, ScreenPicker.severity, ScreenField.scoreCalcWeight,
      ScreenField.companyRegisterId], validationErrors)
    },
    {
      section: CodeEditSectionType.UnitOfMeasureDetails,
      visible: true,
      iconUrl: '/i/case-sections/default.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.UnitOfMeasureDetails, actionType),
      label: (translation: CodetableTranslation) => translation.uom_details,
      ref: unitOfMeasureDetailsSectionRef,
      isValid: validationHighlights([ScreenPicker.defaultUom, ScreenPicker.defaultUomType], validationErrors)
    },
    {
      section: CodeEditSectionType.UnitOfMeasureSets,
      visible: true,
      iconUrl: '/i/case-sections/default.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.UnitOfMeasureSets, actionType),
      label: (translation: CodetableTranslation) => translation.uom_sets,
      ref: unitOfMeasureSetsSectionRef,
      isValid: validationHighlights([ScreenPicker.category, ScreenPicker.defaultUom, ScreenPicker.defaultUomType], validationErrors) &&
        validationPrefixHighlights([ScreenPicker.uomSetValueType, ScreenPicker.uomSetValue, ScreenPicker.uomSetIndicatorValueType,
        ScreenPicker.uomSetIndicatorValue], validationErrors)
    },
    {
      section: CodeEditSectionType.ConversionFactors,
      visible: true,
      iconUrl: '/i/case-sections/default.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.ConversionFactors, actionType),
      label: (translation: CodetableTranslation) => translation.conversion_factors,
      ref: conversionFactorsSectionRef,
      isValid: validationPrefixHighlights(
        [ScreenField.factor, ScreenPicker.uomFrom, ScreenPicker.uomTo, ScreenPicker.uomConversionType],
        validationErrors
      )
    },
    {
      section: CodeEditSectionType.Visibility,
      visible: shouldRenderVisibility(metadata),
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Visibility, actionType),
      label: (translation: CodetableTranslation) => translation.visibility,
      ref: visibilitySectionRef,
      isValid: validationHighlights([CodeFieldWireKey.application, CodeFieldWireKey.subset], validationErrors)
    },
    {
      section: CodeEditSectionType.Translations,
      visible: shouldRenderTranslations(metadata),
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Translations, actionType),
      iconUrl: '/i/case-sections/actions.svg',
      label: (translation: CodetableTranslation) => translation.descriptions_and_translations,
      ref: translationsSectionRef,
      isValid: validationHighlights(['language'], validationErrors)
    }
  ]);
